// src/RawItemsList.js ver 04 Dec 18 6:45 pm - SB118c
// src/RawItemsList.js ver 03 Dec 03 3:28 pm - SB115
import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './App';
import * as rawItemsService from './api/rawItemsService'; // Use new rawItemsService
import * as rawItemCategoryService from './api/rawItemCategoryService'; // NEW: ver 01 - To get categories for dropdown
import PaginationBar2 from './PaginationBar2'; // Assuming PaginationBar is in a separate file

function RawItemsList() {
    const [rawItems, setRawItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const auth = useAuth();

    // Pagination State
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    // Filter State
    // const [statusFilter, setStatusFilter] = useState('no-filter'); // NEW: deprecated by below in ver 01
    // const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    // const dropdownRef = useRef(null);

    const [statusFilter, setStatusFilter] = useState('Active'); // NEW ver 04: Default to 'Active'
    const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false); // NEW ver 01
    const statusDropdownRef = useRef(null); // NEW

    // const [withVariantFilter, setWithVariantFilter] = useState('no-filter'); // NEW ver 01
    // const [isWithVariantDropdownOpen, setIsWithVariantDropdownOpen] = useState(false); // NEW ver 01
    // const withVariantDropdownRef = useRef(null); // NEW ver 01

    const [rawItemCategorySeqIdFilter, setRawItemCategorySeqIdFilter] = useState('no-filter'); // NEW ver 01
    const [rawItemCategoryOptions, setRawItemCategoryOptions] = useState([]); // NEW ver 01: For category dropdown
    const [isCategoryDropdownOpen, setIsCategoryDropdownOpen] = useState(false); // NEW ver 01
    const categoryDropdownRef = useRef(null); // NEW ver 01


    const TENANT_ID = auth.userProfile?.SubsCoDocId;

    useEffect(() => {
        const fetchRawItems = async () => {
            if (!TENANT_ID) {
                setError("No associated company found. Please create one.");
                setLoading(false);
                return;
            }
            setLoading(true);
            setError(null);
            try {
                const token = await auth.getIdToken();
                if (!token) {
                    setError("Authentication required. Please log in.");
                    setLoading(false);
                    return;
                }

                // NEW: ver 01 - Fetch filter options for categories dropdown
                const categoriesResponse = await rawItemCategoryService.getRawItemCategories(TENANT_ID, token, 1, 1000); // Get all categories
                if (categoriesResponse && categoriesResponse.categories) {
                    setRawItemCategoryOptions(categoriesResponse.categories.map(cat => ({
                        name: cat.RawItemCategoryName,
                        seqId: cat.SeqId,
                    })));
                } else {
                    console.warn("Could not fetch raw item categories for filter dropdown.");
                }

                // Pass statusFilter to the service call
                const response = await rawItemsService.getRawItems(TENANT_ID, token, currentPage, itemsPerPage, statusFilter, rawItemCategorySeqIdFilter); 
                setRawItems(response.items);
                setTotalItems(response.totalItems);
                setTotalPages(response.totalPages);

                // SB111 - Manually tried out - It works in emulator mode.
                setIsStatusDropdownOpen(false);
                // setIsWithVariantDropdownOpen(false);
                setIsCategoryDropdownOpen(false);


            } catch (err) {
                console.error("Error fetching raw items from Cloud Function: ", err);
                setError(`Failed to load raw items: ${err.message}`);
            } finally {
                setLoading(false);
            }
        };
        fetchRawItems();
    }, [auth, TENANT_ID, currentPage, itemsPerPage, statusFilter, rawItemCategorySeqIdFilter]); // NEW: ver 01 - Add all filters to dependencies

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    const handleLimitChange = (newLimit) => {
        setItemsPerPage(newLimit);
        setCurrentPage(1); // Reset to first page when limit changes
    };

    // const toggleDropdown = () => { // Deprecated - replaced by below
    //     setIsDropdownOpen(prev => !prev);
    // };

    // NEW: ver01 - Generic toggle for any dropdown
    const toggleDropdown = (setter) => {
        setter(prev => !prev);
    };

    const handleStatusFilterChange = (filter) => {
        setStatusFilter(filter);
        setCurrentPage(1); // Reset to first page on filter change
        // setIsDropdownOpen(false); // Close dropdown
        setIsStatusDropdownOpen(false);
    };

    // const handleWithVariantFilterChange = (filter) => { // NEW ver 01
    //     setWithVariantFilter(filter);
    //     setCurrentPage(1);
    //     setIsWithVariantDropdownOpen(false);
    // };

    const handleCategoryFilterChange = (seqId) => { // NEW ver 01: Filter by SeqId
        setRawItemCategorySeqIdFilter(seqId);
        setCurrentPage(1);
        setIsCategoryDropdownOpen(false);
    };



    useEffect(() => {
        const handleClickOutside = (event) => {
            // if (dropdownRef.current && !dropdownRef.current.contains(event.target)) { // NEW: deprecated below by ver 01
            //     setIsDropdownOpen(false);
            // }
            if (statusDropdownRef.current && !statusDropdownRef.current.contains(event.target)) { // NEW: ver 01
                setIsStatusDropdownOpen(false);
            }
            // if (withVariantDropdownRef.current && !withVariantDropdownRef.current.contains(event.target)) { // NEW: ver 01
            //     setIsWithVariantDropdownOpen(false);
            // }
            if (categoryDropdownRef.current && !categoryDropdownRef.current.contains(event.target)) { // NEW: ver 01
                setIsCategoryDropdownOpen(false);
            }

        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // NEW: ver 01 - Helper to get category name from SeqId for display in header
    const getCategoryNameFromSeqId = (seqId) => {
        const category = rawItemCategoryOptions.find(cat => cat.seqId === seqId);
        return category ? category.name : 'Unknown Category';
    };


    if (loading) return <p>Loading raw items...</p>;
    if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;
    if (!TENANT_ID) return <p style={{ color: 'orange' }}>Please create a company profile to manage raw items.</p>;


    return (
        <div>
            <div className="page-header">
                <h2>Raw Items</h2>
                {/* <Link to={`/raw-items/add/${TENANT_ID}`} className="btn secondary">Add New Raw Item</Link> */}
                <Link to={`/raw-items/add`} className="btn secondary">Add New Raw Item</Link>
            </div>

            <PaginationBar2
                currentPage={currentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                totalItems={totalItems}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
            />

            <table>
                <thead>
                    <tr>
                        <th>Seq ID</th>
                        <th>Raw Item Name</th>
                       <th
                            className="dropdown-th"
                            onClick={() => toggleDropdown(setIsCategoryDropdownOpen)}
                            ref={categoryDropdownRef}
                            title="Click to Filter"
                        >
                            RawItmCateg {rawItemCategorySeqIdFilter !== 'no-filter' && `(${getCategoryNameFromSeqId(rawItemCategorySeqIdFilter)})`}
                            {isCategoryDropdownOpen && (
                                <ul className="dropdown-menu">
                                    <li onClick={() => handleCategoryFilterChange('no-filter')}>&lt;no filter&gt;</li>
                                    {rawItemCategoryOptions.map(cat => (
                                        <li key={cat.seqId} onClick={() => handleCategoryFilterChange(cat.seqId)}>{cat.name}</li>
                                    ))}
                                </ul>
                            )}
                        </th>
                        <th>RawItmCategId</th>
                        <th
                            className="dropdown-th"
                            // onClick={toggleDropdown}
                            onClick={() => toggleDropdown(setIsStatusDropdownOpen)}
                            // ref={dropdownRef}
                            ref={statusDropdownRef}
                            title="Click to Filter"
                        >
                            Status {statusFilter !== 'no-filter' && `(${statusFilter})`}
                            {/* {isDropdownOpen && ( */}
                            {isStatusDropdownOpen && (
                                <ul className="dropdown-menu">
                                    <li onClick={() => handleStatusFilterChange('no-filter')}>&lt;no filter&gt;</li>
                                    <li onClick={() => handleStatusFilterChange('Active')}>Active</li>
                                    <li onClick={() => handleStatusFilterChange('Not-Active')}>Not-Active</li>
                                </ul>
                            )}
                        </th>

                        {/*
                        <th
                            className="dropdown-th"
                            onClick={() => toggleDropdown(setIsWithVariantDropdownOpen)}
                            ref={withVariantDropdownRef}
                            title="Click to Filter"
                        >
                            With Variant {withVariantFilter !== 'no-filter' && `(${withVariantFilter === 'yes' ? 'Yes' : 'No'})`}
                            {isWithVariantDropdownOpen && (
                                <ul className="dropdown-menu">
                                    <li onClick={() => handleWithVariantFilterChange('no-filter')}>&lt;no filter&gt;</li>
                                    <li onClick={() => handleWithVariantFilterChange('yes')}>Yes</li>
                                    <li onClick={() => handleWithVariantFilterChange('no')}>No</li>
                                </ul>
                            )}
                        </th>
                        */}

                        <th>Date Added</th>
                        <th>Date Last Modified</th>
                    </tr>
                </thead>
                <tbody>
                    {rawItems.map(item => (
                        <tr key={item.id}>
                            <td>{item.SeqId}</td>
                            <td>
                                {/* <Link to={`/raw-items/edit/${TENANT_ID}/${item.id}`}> */}
                                <Link to={`/raw-items/edit/${item.id}`}>
                                    {item.RawItemName}
                                </Link>
                            </td>
                            <td>{item.AssociatedRawItemCategory}</td>
                            <td>{item.AssociatedRawItemCategorySeqId}</td>
                            <td>{item.Status}</td>
                            {/* <td>{item.WithVariant ? 'Yes' : 'No'}</td> */}
                            <td>{item.DateAdded ? new Date(item.DateAdded._seconds * 1000).toLocaleString() : 'N/A'}</td>
                            <td>{item.DateLastModified ? new Date(item.DateLastModified._seconds * 1000).toLocaleString() : 'N/A'}</td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <PaginationBar2
                currentPage={currentPage}
                totalPages={totalPages}
                itemsPerPage={itemsPerPage}
                totalItems={totalItems}
                onPageChange={handlePageChange}
                onLimitChange={handleLimitChange}
            />
        </div>
    );
}

export default RawItemsList;